import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'fun-overview-bar',
  templateUrl: './overview-bar.component.html',
  styleUrls: ['./overview-bar.component.scss']
})
export class OverviewBarComponent implements OnInit {

  @Input() data: any;
  @Input() hiddePercent: boolean = false;
  @Input() hiddeObjetive: boolean = false;
  @Input() hiddeLegend: boolean = false;
  @Input() size: string = 'm';

  // Pre-min: barra unificada roja
  barWidthSingle: number = 0;

  // Post-min: verde oscuro creciendo sobre fondo verde claro
  barWidthGreenDark: number = 0;

  percent!: number;
  leftPercent!: number;
  objetiveParse!: string;
  minExceeded: boolean = false;
  hasData: boolean = false;

  constructor(private chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getData();
    this.chdRef.detectChanges();
  }

  getData() {
    this.minExceeded = !!this.data.min_exceeded;
    const contributed = this.data.contributed || 0;
    const reserved = this.data.reservedDisplayAmount || 0;
    const totalRaised = contributed + reserved;
    const hasMin = (this.data.total_official || 0) > 0;
    const total = this.data.total || 0;
    const totalOfficial = this.data.total_official || 0;

    this.hasData = contributed > 0;
    this.objetiveParse = this.data.total_parse;

    if (!this.hasData) {
      this.barWidthSingle = 0;
      this.barWidthGreenDark = 0;
      this.percent = 0;
      this.leftPercent = 0;
      return;
    }

    if (this.minExceeded) {
      // Post-mínimo: fondo verde claro, verde oscuro crece hacia el máximo
      this.barWidthSingle = 0;
      this.barWidthGreenDark = total > 0 ? Math.min((totalRaised / total) * 100, 100) : 100;
      // % sobre el mínimo (puede pasar de 100%)
      this.percent = hasMin ? (totalRaised / totalOfficial) * 100 : (total > 0 ? (totalRaised / total) * 100 : 100);
      this.leftPercent = this.barWidthGreenDark <= 5 ? 6 : this.barWidthGreenDark > 94 ? 90 : this.barWidthGreenDark;
    } else {
      // Pre-mínimo (o sin mínimo): barra roja unificada
      this.barWidthGreenDark = 0;
      const reference = hasMin ? totalOfficial : total;
      this.barWidthSingle = reference > 0 ? Math.min((totalRaised / reference) * 100, 100) : 0;
      this.percent = reference > 0 ? (totalRaised / reference) * 100 : 0;
      this.leftPercent = this.barWidthSingle <= 5 ? 6 : this.barWidthSingle > 94 ? 90 : this.barWidthSingle;
    }

    this.chdRef.detectChanges();
  }

}
